
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"24","height":"24"}},[_c('path',{attrs:{"fill":"#D9D9D9","d":"M0 0h24v24H0z"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"d":"M5.85 17.1c.85-.65 1.8-1.163 2.85-1.538A9.737 9.737 0 0112 15c1.15 0 2.25.187 3.3.562 1.05.375 2 .888 2.85 1.538a7.732 7.732 0 001.363-2.325A7.838 7.838 0 0020 12c0-2.217-.78-4.104-2.337-5.663C16.104 4.78 14.217 4 12 4s-4.104.779-5.662 2.337C4.779 7.896 4 9.783 4 12c0 .983.162 1.908.487 2.775.325.867.78 1.641 1.363 2.325zM12 13c-.983 0-1.813-.338-2.488-1.013C8.837 11.312 8.5 10.483 8.5 9.5c0-.983.338-1.813 1.012-2.488C10.188 6.337 11.017 6 12 6c.983 0 1.813.337 2.488 1.012S15.5 8.517 15.5 9.5c0 .983-.338 1.812-1.012 2.487C13.813 12.662 12.983 13 12 13zm0 9a9.738 9.738 0 01-3.9-.788 10.099 10.099 0 01-3.175-2.137A10.1 10.1 0 012.788 15.9 9.738 9.738 0 012 12a9.74 9.74 0 01.788-3.9 10.099 10.099 0 012.137-3.175c.9-.9 1.958-1.613 3.175-2.138A9.738 9.738 0 0112 2a9.74 9.74 0 013.9.787 10.098 10.098 0 013.175 2.138c.9.9 1.613 1.958 2.137 3.175A9.737 9.737 0 0122 12a9.738 9.738 0 01-.788 3.9 10.1 10.1 0 01-2.137 3.175c-.9.9-1.958 1.612-3.175 2.137A9.738 9.738 0 0112 22z","fill":"#244C73"}})])])
          )
        }
      }
    